import { Button, Flex } from "theme-ui";
import { useEffect, useRef, useState } from "react";
import AccordionPane from "./AccordionPane";

export interface AccordionProps {
  id?: number;
  buttonText: string;
  paneContent: string | JSX.Element;
  url?: string;
  className?: string;
  setPaneHeight?: (value: number) => void;
}

export const AccordionButton = (props: AccordionProps): JSX.Element => {
  const { buttonText, id, className } = props;
  const paneRef = useRef(null);
  const [isActive, setActive] = useState(false);
  const [paneHeight, setPaneHeight] = useState(0);

  useEffect(() => {
    if (window.location.hash === `#question${id}`) {
      setActive(true);
    }
  }, []);

  function toggleAccordion() {
    setActive(!isActive);
  }

  return (
    <Flex
      className={className}
      sx={{
        flexDirection: "column",
        backgroundClip: "border-box",
        bg: "#EDEDED",
        color: "text",
        maxWidth: "100%",
      }}
    >
      <Button
        id={"question" + id}
        sx={{
          outline: "none",
          border: "none",
          display: "flex",
          cursor: "pointer",
          px: [2, null, null, 4],
          py: 1,
          textAlign: "left",
          alignItems: "center",
          // justifyContent: "space-between",
          background: "none",
          width: "100%",
          "&:hover": {
            transform: "none",
            outline: "none",
            bg: "transparent!important",
          },
          "&:active": {
            outline: "none",
          },
          "&:focus": {
            outline: "none!important",
          },
          "&:focus-within": {
            outline: "none",
          },
        }}
        onClick={() => {
          toggleAccordion();
        }}
        role="button"
      >
        <p
          sx={{
            color: "black",
            fontFamily: "Montserrat",
            m: 0,
          }}
          dangerouslySetInnerHTML={{ __html: buttonText }}
        />
        <div
          sx={{
            mr: 3,
            width: 25,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="21.891"
            viewBox="0 0 43.781 21.891"
            sx={{
              verticalAlign: "center",
              transform: isActive
                ? "rotate(180deg) translateY(1px)"
                : "rotate(0deg)",
              transition: "all .3s cubic-bezier(.87,.04,.23,.93)",
              mr: "10px",
            }}
          >
            <g
              id="Group_381"
              data-name="Group 381"
              transform="translate(-43.348 0) rotate(90)"
            >
              <g
                id="Group_308"
                data-name="Group 308"
                transform="translate(0 -87.129)"
              >
                <path
                  id="Path_256"
                  data-name="Path 256"
                  d="M0-43.348,21.887-65.237h0L0-87.129Z"
                  transform="translate(0.004 87.129)"
                  fill="#8fca45"
                />
              </g>
            </g>
          </svg>
        </div>
      </Button>
      <div
        ref={paneRef}
        className="accordion-pane"
        sx={{
          height: isActive ? `${paneHeight}px` : "0px",
          overflow: "hidden",
          maxWidth: "100%",
          color: "text",
          bg: "white",
          px: 3,
          transition: "height .3s  cubic-bezier(.87,.04,.23,.93)",
        }}
      >
        <AccordionPane {...props} setPaneHeight={setPaneHeight} />
      </div>
    </Flex>
  );
};

export default AccordionButton;
